import { Wallet } from '@dynamic-labs/sdk-react-core';
import { ListboxOption } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { useState } from 'react';

import { Loader, tw } from '@repo/ui';
import { getImageUrl, shortenEthAddress } from '@repo/utils';

import { useUnlinkWallet } from '../../../../../../hooks/use-unlink-wallet';

interface WalletOptionProps {
  wallet: Wallet;
}

export const WalletOption: React.FC<WalletOptionProps> = ({ wallet }) => {
  const { handleUnlinkWallet } = useUnlinkWallet();
  const [isUnlinking, setIsUnlinking] = useState(false);

  const handleClick = (wallet: Wallet) => {
    setIsUnlinking(true);
    handleUnlinkWallet(wallet);
  };

  return (
    <ListboxOption
      key={wallet.id}
      value={wallet.address}
      className={tw(
        'group relative cursor-default select-none py-2 pl-3 pr-9 text-white md:pr-3',
        'hover:cursor-pointer data-[focus]:text-white/50 data-[focus]:outline-none',
        'text-sm md:text-base',
      )}
    >
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <div className='relative h-[30px] w-[30px] rounded-full'>
            <Image
              fill
              src={getImageUrl('/claim/images/solana.png')}
              alt='Solana logo'
            />
          </div>
          <span className={tw('block truncate font-semibold tracking-[1.6px]')}>
            {shortenEthAddress(wallet.address, 6, 6)}
          </span>
        </div>

        {!isUnlinking ? (
          <XMarkIcon
            onClick={() => handleClick(wallet)}
            className={tw(
              'mt-0.5 block h-5 w-5 stroke-[3px] opacity-50 hover:cursor-pointer',
            )}
          />
        ) : (
          <div className={tw('mt-0.5 block opacity-50')}>
            <Loader
              size='small'
              theme='secondary'
            />
          </div>
        )}
      </div>
    </ListboxOption>
  );
};
